<template>
  <div>
    <Dropdown :style="{width: '100%', position: 'relative'}" class="customDrop" trigger="click">
      <Input
        clearable
        icon="ios-arrow-down"
        placeholder="请选择调度规则"
        readonly
        type="text"
        v-model.trim="cron"
      ></Input>
      <Dropdown-menu slot="list">
        <div class="cronContainer">
          <Tabs v-model="activeName">
            <Tab-pane label="快捷生成" name="first"></Tab-pane>
            <Tab-pane label="自定义生成" name="second"></Tab-pane>
          </Tabs>
          <div style="margin: 0 0.5rem">
            <CronDefault @change="getCron" ref="CronDefault" v-if="activeName == 'first'"></CronDefault>
            <CronExc @change="getCron" ref="CronExc" v-if="activeName == 'second'"></CronExc>
          </div>
        </div>

        <!-- <CronUi @cronResult="resultValue" ref="CronUi"></CronUi> -->
      </Dropdown-menu>
    </Dropdown>
  </div>
</template>

<script>
import CronExc from "./agility-cron/cron-custom/index"
import CronDefault from "./agility-cron/cron-default/index"
export default {
  name: "crontab",
  data () {
    return {
      showCronTool: false,
      result: "",
      resultForm: {
        cpmEveryStartCron: "",
        cpmEveryEndCron: ""
      },
      cron: '',
      activeName: "first",
      result: "" // 最终的结果表达式
    }
  },
  components: {
    CronExc,
    CronDefault
  },
  props: {
    expression: {
      requred: false,
      default: ''
    },
  },
  methods: {
    getCron: function (value) {
      this.cron = value
      this.$emit("fill", this.cron)
    },
    resolveExp () {
      // 反解析 表达式
      console.log('this.expression', this.expression)
      if (this.expression) {
        this.cron = this.expression
      } else {
        // 没有传入的表达式 则还原
        this.clearCron()
      }
    },
    clearCron () {
      // 还原选择项
      this.cron = ''
    },
  },
  watch: {
    expression: {
      immediate: true,
      handler (newValue, oldValue) {
        this.cron = newValue
      }
    }
  },
  beforeDestroy () {
    console.log('cron beforeDestroy')
  }
};
</script>
<style lang='less'>
.cronContainer {
  width: 100%;
  overflow: hidden;

  .resultContainer {
    margin: 10px;

    .resultBtns {
      text-align: right;
    }
  }

  .box-bottom {
    margin: 5px 0;
    line-height: 1.8rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}
</style>
